import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeComponent } from 'angularx-qrcode';
import { IRequest2FARegistrationCodeResponseDTO } from 'src/app/base/models/models.swagger.generated';
import { PasswordVisibilityDirective } from 'src/app/directives/password-visibility.directive';

@Component({
    selector: 'app-step-qrcode',
    templateUrl: './step-qrcode.component.html',
    styleUrls: ['./step-qrcode.component.scss'],
    imports: [TranslateModule, QRCodeComponent, PasswordVisibilityDirective]
})
export class StepQrcodeComponent{
  @Input() alternateDescription: string;
  @Input() qrData: IRequest2FARegistrationCodeResponseDTO;
  @Output() qrCodeRegistered = new EventEmitter<void>();

  constructor() { }

  public onQrCodeRegistered(): void {
    this.qrCodeRegistered.emit();
  }
}
